<!--Searchbar-->
<div class="row">
  <div class="col-12">
    <form [formGroup]="searchFilterForm" class="d-flex mb-3 px-1">
      <input formControlName="searchFilterField" class="form-control bar" type="search" placeholder="Cerca..."
        aria-label="Search">
      <button type="submit" class="bordersearch" (click)="clickSearch()"><i class="far fa-search grey"></i></button>
    </form>
  </div>
</div>



<!-- Filters -->
<div class="row">
  <div class="col-lg-10 col-md-12 col-sm-12 col-xs-12">
    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 p-1 inlineflex-md">
      <angular2-multiselect *ngIf="menuList" [data]="menuList" [(ngModel)]="selectedMenu" [settings]="menuSettings"
        [ngModelOptions]="{standalone: true}" (onSelect)="changeLengthPage($event)" (onDeSelect)="removeLength()"
        (onDeSelectAll)="removeLength()">
      </angular2-multiselect>
    </div>
  </div>

  <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 text fw-normal size16 txt-remove">
    <span class="clickable" (click)="clickButtonClearFilter()"> Rimuovi filtri</span>
  </div>
</div>

<!-- Riga selezioni -->
<div class="row mt-4 my-2">
  <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 text fw-normal size15">
    {{totalChecked}} elementi selezionati
  </div>
  <div class="col-lg-6 col-md-8 col-sm-8 col-xs-12 text fw-normal size15">
    <app-mass-modify [massModifyItems]="massModifyItems"
      (choiceButtonMassModify)="choiceButtonMassModifyResponse($event)"></app-mass-modify>
  </div>
  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 text fw-normal size15 txt-remove last-text">
    <span (click)="onCancelSelected()">
      Annulla selezione
    </span>
  </div>
</div>

<!-- Table -->
<div class="w-100" [ngClass]="!isEmpty  ? 'table-responsive-sm blocks': 'not_visible'">
  <table aria-describedby="" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table  " style="width: 100%;">
    <thead>
      <tr class="back-white fw-bold">
        <th class="text-center pb-4 border-bottom-0" scope="col">
          <input class="form-check-input checkboxes" type="checkbox" value="" id="check_all" [checked]="statusCheckAll"
            (change)="onCheckAll()">
        </th>
        <th class="pb-4 border-bottom-0 center" scope="col">Data di creazione</th>
        <th class="pb-4 border-bottom-0 center" scope="col">Nome gestione</th>
        <th class="pb-4 border-bottom-0 center" scope="col"></th>
      </tr>
    </thead>
    <tbody [hidden]="isSearching">
      <tr class="table-font" *ngFor="let obj of entityList">
        <td class="text-center">
          <input class="form-check-input checkboxes" type="checkbox" value="" id="check_{{obj.id}}"
            [checked]="obj.checked" (change)="onCheckRow(obj.id)">
        </td>
        <td class="center">{{obj.createdAt}}</td>
        <td class="center">{{obj.name}}</td>
        <td>
          <div class="flex center">
            <a class="pr-5 btn btn-lg"><i (click)="clickButtonUpdate(obj.id)"
                class="far fa-pencil ora clickable"></i></a>
            <a class="pl-0 btn btn-lg"><i (click)="clickButtonDelete(obj.id)"
                class="far fa-trash-alt red clickable"></i></a>
          </div>
        </td>
      </tr>
    </tbody>
    <tfoot [hidden]="!isSearching">
      <tr>
        <td colspan="4">
          <app-spinner-table [visible]="isSearching"></app-spinner-table>
        </td>
      </tr>
    </tfoot>
  </table>
</div>
<div *ngIf="isEmpty" class="table-responsive-sm blocks no-data w-100">
  <div class="result-message">
    <span class="message-font">La ricerca non ha prodotto risultati!</span>
  </div>
</div>
<!-- FloatingBar-->
<app-floatingbar [toggleParam]="true" [items]="menuItems" (choiceButton)="choiceButtonResponse($event)">
</app-floatingbar>